import { Pipe, PipeTransform } from '@angular/core';
import { FontSize } from '../settings-form/settings-form.component';

@Pipe({
  name: 'fontSizeClass',
})
export class FontSizeClassPipe implements PipeTransform {

  transform(value: FontSize, ...args: unknown[]): unknown {

    switch (value) {
      case FontSize.ExtraSmall:
        return 'font-size-xs';
      case FontSize.Small:
        return 'font-size-sm';
      case FontSize.Default:
        return '';
      case FontSize.Large:
        return 'font-size-lg';
      case FontSize.ExtraLarge:
        return 'font-size-xl';
      default:
        return '';
    }

  }

}
